export default __webpack_public_path__ + "static/media/ds-prog-js.7205630d.png";